import React from 'react';
import { Outlet, useOutletContext, useParams } from 'react-router-dom';
import { BusinessObject } from '../../../../models/interfaces/BusinessObject.interface';
import { User } from '../../../../models/interfaces/User.interface';
import businessObjectService from '../../../../services/business-object.service';
import UserInfoCardComponent from '../user-context/components/user-info-card/user-info-card.component';

export default function BusinessObjectContext() {
  const { user } = useOutletContext<{ user: User }>();
  const { boId } = useParams();

  const [businessObject, setBusinessObject] = React.useState<BusinessObject>(null);
  React.useEffect(() => {
    const getBusinessObject = async (userEmail: string, boId: number) => {
      const data = await businessObjectService.getBusinessObjectById(userEmail, boId);
      setBusinessObject(data);
    };

    if (user?.id && boId) {
      getBusinessObject(user?.email, Number(boId));
    }
  }, [boId, user]);

  return (
    <>
      <UserInfoCardComponent user={user}></UserInfoCardComponent>
      <Outlet context={{ user, businessObject }} />
    </>
  );
}
